import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as BuildWiseLogo } from 'assets/icons/login_logo_large.svg';
import { ReactComponent as BuildWiseTitle } from 'assets/icons/logo_title.svg';

function LargeBrandBanner() {
  return (
    <>
      <BuildWiseTitle />
      <BuildWiseCaption>Build with Collective Wisdom.</BuildWiseCaption>
      <BuildWiseLogo className="logo" />
    </>
  );
}

const BuildWiseCaption = styled(Typography, { label: 'BuildWiseCaption' })(({ theme }) => ({
  fontSize: 24,
  fontWeight: 500,
  lineHeight: '38px',
  color: theme.palette.secondary.main,
  marginTop: 16,
  marginBottom: 80,
}));

export default LargeBrandBanner;
